<template>
  <div class="">
    <alarm-reminder-edit
        v-model:show="showReminder"
        :reminder-prop="selectedReminder"
        v-on:update:reminder="updateReminderFromEditModal($event)"
        :un-snooze-notification-enabled="unSnoozeNotificationEnabled"
    ></alarm-reminder-edit>

    <!-- Table -->
    <ajax-table :data="data"
                :headers="headers"
                v-model:loading="ajaxTable.loading"
                v-model:search="ajaxTable.search"
                v-model:sort-by="ajaxTable.sortBy"
                v-model:sort-desc="ajaxTable.sortDesc"
                v-model:page="ajaxTable.page"
                v-model:items-per-page="ajaxTable.itemsPerPage"
                v-model:page-info="ajaxTable.pageInfo"
                @rowSelected="showReminderModal"
                :exportable="false"
                @loadData="getData"
    >

      <!-- Column 1: User Name-->
      <template #col-1="props">
        <div    class="flex flex-col items-start justify-center">
                    <span   class="my-1 text-gray-700">
                        {{ props.row.display_name }}
                    </span>
        </div>
      </template>

      <!-- Alarm Notification Delay Column -->
      <template #col-2="props">
        <div    class="flex flex-col items-start justify-center">
                    <span   class="my-1 text-gray-700">
                      {{props.row.pivot.delay_time}}
                    </span>
        </div>
      </template>

      <template #col-3="props">
      <!-- Column 3: Renotification Interval-->
        <div    class="flex flex-col items-start justify-center">
                    <span   class="my-1 text-gray-700">
                      {{ props.row.pivot.renotification_time }}
                    </span>
        </div>
      </template>

    </ajax-table>


    <!--    Notification modal for the results -->
    <notification-modal
        v-model:is-open="showResultModal"
    >
      <template #title-content>
        Update Successful!
      </template>
      {{ modalText }}
    </notification-modal>

  </div>
</template>
<script>

import axios from "axios"
import {SonicuCoreMixin} from "@/mixins/SonicuCoreMixin";
import {iconNamesMixin} from '@/mixins/IconNamesMixin';
import Pagination from "@/components/Pagination"
import ItemsPerPageSelect from "@/components/ItemsPerPageSelect"
import FloatingInput from "@/components/elements/FloatingInput";
import Select2 from '@/components/elements/select2'
import GreenButton from "@/components/elements/green-button";
import AjaxTable from "@/components/elements/AjaxTable";
import {ajaxTableMixin} from "@/mixins/ajaxTableMixin";
import Loading from "@/components/elements/loading";
import SmallColoredCheck from "@/components/elements/SmallColoredCheck";
import {UrlParamsMixin} from "@/mixins/UrlParamsMixin";
import _isNil from "lodash";
import AlarmProfileEdit from "@/components/alarmProfiles/alarmProfilesEdit";
import _ from "lodash";

export default {
  emits: [],
  name: "AlarmReminderIndex",
  mixins: [SonicuCoreMixin, iconNamesMixin, ajaxTableMixin, UrlParamsMixin],
  components: {
    SmallColoredCheck,
    Loading, AjaxTable, GreenButton, Pagination, ItemsPerPageSelect, FloatingInput, Select2
  },
  props: {
    unSnoozeNotificationEnabled: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      data: [],
      headers: [
        {
          name: 'Name',
          sortBy: 'name',
          show: 'sm',
          key: 'name',
        },
        {
          name: 'Alarm Notification Delay (Minutes)',
          sortBy: '',
          show: 'md',
          key: 'notification_delay',
        },
        {
          name: 'Re-notification Interval (Minutes)',
          sortBy: '',
          show: 'md',
          key: 'renotification_interval',
        },
      ],
      requestNumber: 0,
      processing: false,

      // For Modal
      selectedReminder: null,
      selectedReminderIndex: null,
      showReminder: false,
      showResultModal: false,
      modalText: '',

    }
  },
  created() {
  },
  mounted() {
  },
  methods: {
    getData() {
      this.ajaxTable.loading = true
      this.requestNumber++
      let params = JSON.parse(JSON.stringify(this.ajaxTable))
      params.requestNumber = this.requestNumber
      axios.get(this.company.buildCompanyApiInternalRoute('alarm-reminders'),
          {
            params: params,
          }
      ).then(response => {
        let data = response.data.data;
        data.meta = {};
        data.meta.current_page = data.current_page;
        data.meta.from = data.from;
        data.meta.to = data.to;
        data.meta.path = data.path;
        data.meta.per_page = data.per_page;
        data.meta.last_page = data.last_page;
        data.meta.requestNumber = response.data.requestNumber;
        if (data.meta.requestNumber !== `${this.requestNumber}`) {
          return
        }
        this.ajaxUpdateTableData(data); // This sends the data to the mixin for AjaxTable
        this.data = !_.isNil(data.data) ? data.data : [];
      }).catch(error => {
        console.log(error)
      }).then(() => {
        this.ajaxTable.loading = false
      })
    },
    showReminderModal(rowIndex) {
      this.selectedReminder = this.data[rowIndex];
      this.selectedReminderIndex = rowIndex;
      this.urlParamsStore('reminder', this.data[rowIndex].id);
      this.showReminder = true;
    },
  },
  computed: {},
  watch: {
  },
}
</script>

<style scoped>

</style>